// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { 
  Card
} from "@mui/material";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ExperienceCard({ title, location, year, children, ...rest }) {
  return (
    <MKBox mb={2}>
      <Card>
        <MKBox py={2} px={3}>
          <MKBox display="flex" justifyContent="space-between" alignItems="center" {...rest} sx={{ cursor: "default" }}>
            <MKTypography variant="h4" color="dark" sx={{ userSelect: "none" }}>
              {title}
            </MKTypography>
            <MKTypography variant="h5" color="dark" sx={{ userSelect: "none" }}>
              {year}
            </MKTypography>
          </MKBox>
          <MKBox display="flex" justifyContent="space-between" alignItems="center" pb={2} {...rest} sx={{ cursor: "default", borderBottom: ({ borders: { borderWidth, borderColor } }) => `${borderWidth[1]} solid ${borderColor}` }}>
            <MKTypography variant="h6" color="#666666" sx={{ userSelect: "none" }}>
              {location}
            </MKTypography>
          </MKBox>
        </MKBox>
        <MKBox display="flex" justifyContent="space-between" alignItems="center" pb={2} px={3} {...rest} >
          {children}
        </MKBox>
      </Card>
    </MKBox>
  );
}

// Typechecking props for the FaqCollapse
ExperienceCard.propTypes = {
  title: PropTypes.string.isRequired,
  location: PropTypes.string,
  year: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default ExperienceCard;